import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Dayjs } from 'dayjs';

interface ComposeEmailSliceState {
    emailData: any;
    scheduleDate: any;
    scheduleTime: any;
    isSubmitted: boolean;
    isError: boolean;
    isSuccess: boolean;
    apiResponseMessage: string;
    draftBtnLoading: boolean;
    sendBtnLoading: boolean;
}

const initialState: ComposeEmailSliceState = {
    emailData: null,
    scheduleDate: null,
    scheduleTime: null,
    isSubmitted: false,
    isError: false,
    isSuccess: false,
    apiResponseMessage: "",
    draftBtnLoading: false,
    sendBtnLoading: false,
};

const composeEmailSlice = createSlice({
    name: 'schedule',
    initialState,
    reducers: {
        setEmailData: (state, action: PayloadAction<any>) => {
            state.emailData = action.payload;
        },
        setScheduleDate: (state, action: PayloadAction<Dayjs>) => {
            state.scheduleDate = action.payload;
        },
        setScheduleTime: (state, action: PayloadAction<Dayjs>) => {
            state.scheduleTime = action.payload;
        },
        setIsSubmitted: (state, action: PayloadAction<boolean>) => {
            state.isSubmitted = action.payload;
        },
        setIsError: (state, action: PayloadAction<boolean>) => {
            state.isError = action.payload;
        },
        setIsSuccess: (state, action: PayloadAction<boolean>) => {
            state.isSuccess = action.payload;
        },
        setApiResponseMessage: (state, action: PayloadAction<string>) => {
            state.apiResponseMessage = action.payload;
        },
        setDraftBtnLoading: (state, action: PayloadAction<boolean>) => {
            state.draftBtnLoading = action.payload;
        },
        setSendBtnLoading: (state, action: PayloadAction<boolean>) => {
            state.sendBtnLoading = action.payload;
        },
        resetSchedule: (state) => {
            state.scheduleDate = null;
            state.scheduleTime = null;
        },
    },
});

export const { setEmailData, setScheduleDate, setScheduleTime, resetSchedule, setIsSubmitted, setIsError, setIsSuccess, setApiResponseMessage, setDraftBtnLoading, setSendBtnLoading } = composeEmailSlice.actions;

export default composeEmailSlice.reducer;
